import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classes from './UserListItem.module.css';
import { getRgbFromColorName } from 'shared/utility';

const userListItem = (props) => {
  // Right now the api returns the base image hosting url for profile images for users who have no profile image. As a workaround,
  // we are assuming that any ThumbURL that ends in '/' is blanks
  const thumbURL = props.thumbURL && props.thumbURL.charAt(props.thumbURL.length - 1) !== '/' ? props.thumbURL : null;
  return (
    <div key={props.userId} className={props.selected ? [classes.User, classes.Selected].join(' ') : classes.User} onClick={props.clicked}>
      <div className={classes.UserDetails}>
        {thumbURL ? (
          <img
            style={{
              border: props.color ? `2px solid ${getRgbFromColorName(props.color)}` : '2px solid rgb(108, 162, 183)',
            }}
            className={classes.ThumbImage}
            src={thumbURL}
            alt="user avatar"
          />
        ) : (
          <FontAwesomeIcon
            style={{ color: props.color ? getRgbFromColorName(props.color) : 'hsl(0, 0%, 90%)' }}
            icon="user-circle"
            className={classes.UserIcon}
          />
        )}

        <span>{props.name}</span>
      </div>
      <FontAwesomeIcon icon="check" className={classes.CheckMark} />
    </div>
  );
};

export default userListItem;
